import {
	businessConstants
} from './business.constants';
import {
	businessService
} from 'services';

export const businessActions = {
	sendBusiness
};

function sendBusiness(payload) {
	return (dispatch) => {
		dispatch(request());
		return businessService.sendBusiness(payload)
			.then(
				result => {
					dispatch(success())
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error))
					return Promise.reject(error);
				}
			);
	};

	function request() {
		return {
			type: businessConstants.SEND_BUSINESS_REQUEST,
		};
	}

	function success() {
		return {
			type: businessConstants.SEND_BUSINESS_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: businessConstants.SEND_BUSINESS_ERROR,
			error,
		};
	}
}